module.exports = __webpack_public_path__ + "img/preview-lg.d70baa9e.png";